import React from 'react';

import Accordion from 'components/Accordion';
import List from './List';
import New from './New';

export default function PastSimulations() {
  return (
    <Accordion.Item eventKey="4">
      <Accordion.Header>Incluir Simulações antigas</Accordion.Header>
      <Accordion.Body>
        <List />
        <New />
      </Accordion.Body>
    </Accordion.Item>
  );
}
